/*
 * Per-product free gift.
 *
 * A product page tagged with the "Free gift" block adds the private line item property
 * `_product_gift` = "<gift variant id>|<one|match>|<cart badge text>" to the main product. This script keeps
 * the matching €0 gift line (`_auto_gift` + `_gift_tier=product_gift`, rendered by snippets/line-item.liquid)
 * in the cart for exactly as long as the product is in the cart. It does nothing for carts without that property.
 */
(function () {
  var TIER = 'product_gift';
  var FLAG = 'maleup_product_gift_active';

  var queue = Promise.resolve();

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function remember(active) {
    try {
      if (active) {
        window.localStorage.setItem(FLAG, '1');
      } else {
        window.localStorage.removeItem(FLAG);
      }
    } catch (_) {}
  }

  function wasActive() {
    try {
      return window.localStorage.getItem(FLAG) === '1';
    } catch (_) {
      return false;
    }
  }

  function parseGiftProperty(value) {
    var parts = String(value || '').split('|');
    var variantId = parts[0].trim();

    if (!/^\d+$/.test(variantId)) {
      return null;
    }

    return {
      variantId: variantId,
      mode: parts[1] === 'match' ? 'match' : 'one',
      badge: (parts[2] || '').trim() || 'Geschenk'
    };
  }

  function isGiftLine(item) {
    return Boolean(item.properties) && item.properties._auto_gift === 'true' && item.properties._gift_tier === TIER;
  }

  function hasProductGiftLines(cart) {
    return cart.items.some(function (item) {
      return Boolean(item.properties && item.properties._product_gift) || isGiftLine(item);
    });
  }

  // gift variant id -> { quantity, badge }
  function buildDesiredGifts(cart) {
    var desired = {};

    cart.items.forEach(function (item) {
      var gift = item.properties && item.properties._product_gift ? parseGiftProperty(item.properties._product_gift) : null;

      if (!gift) {
        return;
      }

      var entry = desired[gift.variantId] || (desired[gift.variantId] = { quantity: 0, badge: gift.badge });
      entry.quantity = gift.mode === 'match' ? entry.quantity + item.quantity : Math.max(entry.quantity, 1);
    });

    return desired;
  }

  function fetchCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json();
    });
  }

  function post(path, body) {
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
  }

  function fetchBundledCart() {
    var sections = [];

    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sections }
    }));

    return fetchCart().then(function (cart) {
      if (sections.length === 0) {
        return cart;
      }

      return fetch(root() + '?sections=' + sections.join(','))
        .then(function (response) { return response.json(); })
        .then(function (bundled) {
          cart.sections = bundled;
          return cart;
        })
        .catch(function () { return cart; });
    });
  }

  async function sync() {
    var cart = await fetchCart();
    var desired = buildDesiredGifts(cart);
    var changed = false;

    remember(Object.keys(desired).length > 0);

    // 1. Fix or remove existing gift lines.
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];

      if (!isGiftLine(item)) {
        continue;
      }

      var wanted = desired[String(item.variant_id)];
      var wantedQuantity = wanted ? wanted.quantity : 0;

      if (item.quantity !== wantedQuantity) {
        var response = await post('cart/change.js', { id: item.key, quantity: wantedQuantity });
        changed = changed || response.ok;
      }
    }

    // 2. Add missing gift lines. A gift of the same product that the global auto-gift tiers already added counts too.
    var presentVariantIds = {};
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._auto_gift === 'true') {
        presentVariantIds[String(item.variant_id)] = true;
      }
    });

    for (var variantId in desired) {
      if (presentVariantIds[variantId]) {
        continue;
      }

      var added = await post('cart/add.js', {
        id: Number(variantId),
        quantity: desired[variantId].quantity,
        properties: {
          _auto_gift: 'true',
          _gift_tier: TIER,
          _gift_badge_text: desired[variantId].badge
        }
      });
      changed = changed || added.ok;
    }

    if (changed) {
      var updatedCart = await fetchBundledCart();
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'product-gift:sync', cart: updatedCart }
      }));
    }
  }

  function schedule(cart) {
    // Cheap exit for the vast majority of carts: nothing to do without a tagged product or a gift line.
    if (cart && cart.items && !hasProductGiftLines(cart)) {
      remember(false);
      return;
    }

    queue = queue.then(sync).catch(function () {});
  }

  document.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};

    if (String(detail.baseEvent || '').indexOf('product-gift:') === 0) {
      return;
    }

    schedule(detail.cart);
  });

  // Catch products that were removed while no listener was active (e.g. a full page reload on the cart page).
  window.setTimeout(function () {
    if (wasActive()) {
      schedule(null);
    }
  }, 1500);
})();
